//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goConsultant from '@/common/mixins/goConsultant'
export default {
    props: {
        items: Array
    },
    mixins: [
        goConsultant,
    ]
}
